import React from 'react'
import type { QuickbetShare as QuickbetShareType } from '@core/Areas/ShareBet/types'
import { BetSlipShare } from '../BetSlipShare'

export const QuickbetShare: React.FC<{
  share: QuickbetShareType['share']
  isCostShared: boolean
}> = ({ share, isCostShared }) => {
  return (
    <BetSlipShare
      share={{ items: share.items, isBetPlaced: true, ticketSequence: 0 }}
      isCostShared={isCostShared}
    />
  )
}
